import {AppNotification, NotificationType} from '../types/notifications.types';

interface NotificationTabDefinition {
  label: string;
  value: NotificationType;
  predicate: (notification: AppNotification) => boolean;
}

export const NOTIFICATION_TABS: NotificationTabDefinition[] = [
  {
    label: 'Все',
    value: 'all',
    predicate: () => true,
  },
];
